module.exports = "/hwa/_next/static/images/furnitureCollection-1989ee869d9a09d9564e1b3d4d679aa5.png";